import styled, { css } from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  height: 100dvh;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  flex-direction: row;
  background-color: var(--lisa-container);
  overflow-X: hidden;
  height: calc(100vh - 7%);
  max-height: calc(100vh - 7%);
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 93%;
    min-height: 0;
    width: 100%;
    background-color: var(--lisa-container);
    box-sizing: border-box;
    overflow: hidden;
  }

  .LisaContainer {
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 100%;
    gap: 0;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      flex: 1;
      min-height: 0;
    }
  }

  .LisaContainer.tour-active {
    z-index: 10004;
  }
`;


export const AiContainer = styled.div<{ $isMinimized?: boolean;}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 0.2s ease;

  ${({ $isMinimized }) =>
    $isMinimized &&
    css`
      position: fixed;
      bottom: 1.5rem;
      right: 1.5rem;
      width: 30vw;
      height: 70vh;
      z-index: 1000;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      overflow: hidden;

      @media (max-width: 768px) {
        display: none;
      }
    `}
`;

export const OpenButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 100px;
  height: 100px;
  min-width: 56px;
  min-height: 56px;
  padding: 0;
  background-color: var(--hover);
  cursor: pointer;
  z-index: 10005;
  overflow: hidden;
  border:none;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.5);


  img{
    width: 40px;
    height: 40px;
  }

  &:hover {
      background-color: var(--gray);
      transform: scale(1.05);
    }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    flex: 1;
    min-height: 0;
    height: auto;
  }
`;



export const AIButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: fixed;
  width: auto;
  height: auto;
  font-size: 1.2rem;
  z-index: 2;
  white-space: nowrap;

  border: none;
  bottom: 7rem;
  right: 1.5rem;
  border-radius: 1rem;
  padding: 0.5rem 1.8rem 0.5rem 1.3rem;
  color: var(--white);

  cursor: pointer;
  overflow: hidden;

  background: linear-gradient(
    90deg,
    #1e49b9 0%,
    #603b98 50%,
    #c02977 100%
  );

  img {
    width: 3rem;
    height: 3rem;
    flex-shrink: 0;
  }

  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      110deg,
      transparent 20%,
      rgba(255, 255, 255, 0.25) 50%,
      transparent 80%
    );
    transform: translateX(-100%);
    transition: transform 0.6s ease;
  }

  &:hover {
    transform: translateY(-3px) scale(1.02);

    box-shadow:
      0 8px 20px rgba(30, 73, 185, 0.2),
      0 5px 15px rgba(206, 44, 128, 0.1);

    &::before {
      transform: translateX(100%);
    }
  }

  &:active {
    transform: translateY(-1px) scale(0.98);
  }

  @media (max-width: 768px) {
    bottom: 6rem;
    right: 1rem;
    padding: 0.75rem;
    border-radius: 8px;
    gap: 0;

    span {
      display: none;
    }

    img {
      width: 3rem;
      height: 3rem;
    }
  }
`;




